import Controller from '@ember/controller';

export default class NoticeController extends Controller {}
